import { put, select } from 'redux-saga/effects';
import { collectionSelector } from 'common/selectors/collection';
import { markAsStartVideoApi } from 'common/api/videos';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import i18next from 'i18next';
import { collectionSetInStoreAction } from 'common/actions';
import { fetchChannelsApi, fetchCollectionApi } from 'common/api';
import { channelsSuccessAction } from '../../actions/channels';
import { getVideosPerPageSelector } from 'common/selectors';

export function* markAsStartVideoEffect({ payload: { video, channelId, pageNumber, sort } }) {
  try {
    const perPage = yield select(getVideosPerPageSelector);
    const { channelId } = yield select(collectionSelector);
    yield markAsStartVideoApi(channelId, video.id);
    const newCollection = yield fetchCollectionApi({
      channelId: channelId,
      pageNum: pageNumber,
      sorting: sort,
      perPage,
      featuredFirst: true,
    });
    yield put(collectionSetInStoreAction(newCollection));
    const channels = yield fetchChannelsApi();
    yield put(channelsSuccessAction(channels));
    yield put(
      reduxNotificationAction(
        i18next.t('mark_channel_start_video_notification_success'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.SUCCESS
      )
    );
  } catch (error) {
    yield put(
      reduxNotificationAction(
        i18next.t('mark_channel_start_video_notification_error'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.ERROR
      )
    );
  }
}
